import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
import PlaceRolesModel from './PlaceRolesModel';

const BASE = BaseModel.getApiBasePath() + '/api/v1/core/parkinglocations';

export default new class ParkinglocationPlacesModel {

  constructor() { }

  async getAll(parkingLocationId) {
    let filter = {};
    let placesResp = await axios.get(BASE + '/' + parkingLocationId + '/places', {
      params: {
        access_token: UserModel.getAccessToken(),
        filter: filter
      }
    });
    let roles = await PlaceRolesModel.getAll();
    let places = [];
    for (let place of placesResp.data) {
      let role = _.find(roles, { id: place.actualRoleID });
      places.push(Object.assign({}, place, { actualRoleName: role.name }))
    }
    return places;
  }

  create(parkingLocationId, data) {
    return new Promise((resolve, reject) => {
      axios.post(BASE + '/' + parkingLocationId + '/places',
        Object.assign({}, data, { occ: 0, lastStateChange: moment.utc().format() }), {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  remove(parkingLocationId, id) {
    return new Promise((resolve, reject) => {
      axios.delete(BASE + '/' + parkingLocationId + '/places/' + id, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  update(parkingLocationId, id, data) {
    if (data.id !== undefined) {
      delete data.id;
    }
    return new Promise((resolve, reject) => {
      axios.put(BASE + '/' + parkingLocationId + '/places/' + id, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

}


// WEBPACK FOOTER //
// ./src/components/ParkinglocationPlacesModel.js